module.exports = __webpack_public_path__ + "img/state_seal_black.c66335eb.png";